module.exports = __webpack_public_path__ + "img/water_droplet_4.e80022f3.svg";